import { Suspense, useState } from 'react'
import VideoSkeleton from './VideoSkeleton'
import VideoPlayer from './VideoPlayer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp, faCircleCheck } from '@fortawesome/free-solid-svg-icons'

const InterviewAndFeedback = () => {

    const [showVideo, setShowVideo] = useState(false);

    return (
        <div className='mt-3 bg-[#2D4F71] p-3 rounded-xl hidden'>
            <div className='flex items-center justify-between' onClick={() => setShowVideo(!showVideo)}>
                <div className='flex'>
                    <FontAwesomeIcon icon={faCircleCheck} className='text-[#55A47E] bg-white rounded-full text-xl mr-2'/>
                    <p className='font-medium'>Interview Training & Feedback</p>
                </div>
                {!showVideo ?  <FontAwesomeIcon icon={faChevronDown} className='text-xl font-extrabold ml-2' onClick={() => setShowVideo(!showVideo)}/> : <FontAwesomeIcon icon={faChevronUp} className='text-xl font-extrabold ml-2 mt-1.5' />}
            </div>
            {showVideo && <Suspense fallback={<VideoSkeleton/>}><VideoPlayer/></Suspense>}
        </div>
    )
}

export default InterviewAndFeedback
